import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from '@app/app.module';
import { LicenseManager } from 'ag-grid-enterprise';
import { environment } from './environments/environment';


if (environment.production) {
  enableProdMode();
} else {
  console.log('1One dev.');
}

LicenseManager.setLicenseKey(environment.agGridLicenseKey);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
